import { render, staticRenderFns } from "./AddFriendListBtn.vue?vue&type=template&id=4aa30208&scoped=true&"
import script from "./AddFriendListBtn.vue?vue&type=script&lang=js&"
export * from "./AddFriendListBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddFriendListBtn.vue?vue&type=style&index=0&id=4aa30208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa30208",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aa30208')) {
      api.createRecord('4aa30208', component.options)
    } else {
      api.reload('4aa30208', component.options)
    }
    module.hot.accept("./AddFriendListBtn.vue?vue&type=template&id=4aa30208&scoped=true&", function () {
      api.rerender('4aa30208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/PostForm/Privacy/AddFriendListBtn.vue"
export default component.exports